import React from 'react'
import {Link }from 'react-router-dom'

export default function Header() {
    return (
        <div className="header">
      <h1> TodoList</h1> 
      <Link className ="link1"  to ="/"> Home  |</Link>
      <Link className ="link1" to ="/About"> About</Link>

            
        </div> 
    )
}
